export default __webpack_public_path__ + "static/media/card.36aef71a.svg";